<template>
  <b-modal ref="modal" id="accountCreationModal" hide-header hide-footer centered dialog-class="login-modal-dialog" class="account-creation-modal">
    <div class="modal-body p-4">
      <div class="row">
        <div class="col-12 d-flex justify-content-end">
          <button type="button" class="btn-close shadow-none" @click="hide" aria-label="Close"></button>
        </div>

        <div class="col-12 text-center mt-2">
          <div style="height:70px; display:flex; align-items:center; justify-content:center;">
            <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 48 48" fill="none">
              <g clip-path="url(#clip0_4501_53276)">
                <path d="M33 18C33 20.3869 32.0518 22.6761 30.364 24.364C28.6761 26.0518 26.3869 27 24 27C21.6131 27 19.3239 26.0518 17.636 24.364C15.9482 22.6761 15 20.3869 15 18C15 15.6131 15.9482 13.3239 17.636 11.636C19.3239 9.94821 21.6131 9 24 9C26.3869 9 28.6761 9.94821 30.364 11.636C32.0518 13.3239 33 15.6131 33 18Z" fill="#F84B04"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24ZM24 3C20.0453 3.00021 16.1711 4.11709 12.8232 6.22208C9.47532 8.32708 6.78985 11.3346 5.07589 14.8986C3.36194 18.4625 2.68916 22.438 3.135 26.3675C3.58083 30.2969 5.12716 34.0206 7.596 37.11C9.726 33.678 14.415 30 24 30C33.585 30 38.271 33.675 40.404 37.11C42.8728 34.0206 44.4192 30.2969 44.865 26.3675C45.3108 22.438 44.6381 18.4625 42.9241 14.8986C41.2102 11.3346 38.5247 8.32708 35.1768 6.22208C31.8289 4.11709 27.9547 3.00021 24 3Z" fill="#F84B04"/>
              </g>
              <defs>
                <clipPath id="clip0_4501_53276">
                  <rect width="48" height="48" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>

        <div class="col-12 text-center mt-3">
          <div class="login-modal-header" style="font-size:28px; font-weight:700; line-height:1;">Account Creation Unavailable</div>

          <div class="login-modal-body mt-3">
            Account creation is currently disabled. Please contact our support team to request access.
          </div>

          <div class="login-modal-email mt-3">
            Email our support at:
            <a href="mailto:kantoads@peddlr.ph" style="color: #000; text-decoration: none;">kantoads@peddlr.ph</a>
          </div>

          <b-button class="w-100 shadow-none login-modal-btn mt-4" style="height:58px; font-family:Poppins; font-size:15px; font-weight:500; background-color:#F84B04; border-color:#F84B04; color:#fff;" @click="hide">
            OK
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'AccountCreationUnavailableModal',
  methods: {
    show() {
      this.$refs.modal && this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal && this.$refs.modal.hide();
    },
  },
};
</script>

<style>
.login-modal-dialog {
  max-width: 520px;
}
.login-modal-dialog .modal-content {
  border-radius: 8px;
  overflow: hidden;
}
.account-creation-modal .modal-body {
  padding: 24px;
}

.account-creation-modal .login-modal-email {
  font-family: Roboto;
  font-size: 15px;
  font-weight: 500;
  margin-top: 12px;
}
.account-creation-modal .login-modal-email a {
  color: #000;
  text-decoration: underline;
  font-weight: 600;
}
.account-creation-modal .login-modal-btn {
  background-color: #F84B04;
  border-color: #F84B04;
  color: #fff;
  font-weight: 600;
  border-radius: 8px;
}
.account-creation-modal .login-modal-btn:hover {
  background-color: #e03e00;
  border-color: #e03e00;
}

@media (max-width: 576px) {
  .login-modal-dialog {
    max-width: 92%;
    margin: 1.25rem;
  }
  .account-creation-modal .login-modal-header {
    font-size: 20px;
  }
}
</style>
